import React, { Dispatch, ReactNode, createContext, useReducer } from 'react';

import * as types from './types';
import { AssignmentsState } from '../../types';
import { urlService } from '../../services/urlService';
import { URL_PARAMS } from '../../consts/constants';

type AssignmentsAction = { type: string; payload: AssignmentsState };

const initialState: AssignmentsState = {
  selectedAssignmentId: urlService.getQueryStringValue(URL_PARAMS.ASSIGNMENT_ID)
    ? +urlService.getQueryStringValue(URL_PARAMS.ASSIGNMENT_ID)!
    : 0,
};

const assignmentReducer = (
  state: AssignmentsState,
  action: AssignmentsAction,
): AssignmentsState => {
  switch (action.type) {
    case types.SET_ASSIGNMENT_ID:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return initialState;
  }
};

type AssignmentsContextType = [
  AssignmentsState | null,
  Dispatch<AssignmentsAction>,
];
export const AssignmentContext = createContext<AssignmentsContextType>([
  initialState,
  () => initialState,
]);

const AssignmentsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [assignmentsState, assignmentsDispatch] = useReducer(
    assignmentReducer,
    initialState,
  );

  return (
    <AssignmentContext.Provider value={[assignmentsState, assignmentsDispatch]}>
      {children}
    </AssignmentContext.Provider>
  );
};

export default AssignmentsProvider;
